import React from 'react';

import { useTheme } from '@cobalt/react-theme-provider';
import Box from '@cobalt/react-box';
import Flex from '@cobalt/react-flex';
import Icon from '@cobalt/react-icon';
import List, { ClickableItem } from '@cobalt/react-list';
import { Text } from '@cobalt/react-typography';

import { CascaderSelectProps } from './index';
import { CascaderSelectOptionType } from '../types';

export interface CascaderItemProps extends Pick<CascaderSelectProps, 'style' | 'backText'> {
  selectedValue: string;
  options: CascaderSelectOptionType[];
  level?: number;
  onBack?: (level: number) => void;
  onChangeSelect: (value: string, level: number) => void;
}

const CascaderItem = (props: CascaderItemProps) => {
  const { selectedValue, options, level = 0, backText, onBack, onChangeSelect } = props;

  const theme = useTheme();

  return (
    <List data-testid="cascaderItem" style={{ width: '100%' }}>
      {level > 1 && (
        <Flex padding={2} onClick={() => onBack?.(level)}>
          <Icon name="chevron_left" color={theme.primary600} size="tiny" />
          <Box paddingLeft={2}>
            <Text color={theme.primary600}>{backText}</Text>
          </Box>
        </Flex>
      )}

      {options.map((item) => {
        const label = item.render?.() || item.label;

        return (
          <ClickableItem
            key={item.value}
            selected={item.value === selectedValue}
            disabled={item.disabled}
            title={item.title || ''}
            onClick={() => onChangeSelect(item.value, level)}
          >
            <Flex padding={2}>
              {/* Icon */}
              <Icon
                name="check"
                size="tiny"
                style={{ visibility: item.value === selectedValue ? 'visible' : 'hidden' }}
              />

              {/* Option label */}
              <Box paddingLeft={2} style={{ overflow: 'hidden' }}>
                {typeof label === 'string' ? (
                  <Text title={label} truncated>
                    {label}
                  </Text>
                ) : (
                  label
                )}
              </Box>
            </Flex>
          </ClickableItem>
        );
      })}
    </List>
  );
};

export default CascaderItem;
